import type { Styles } from 'src/theme/themes';

export const styles = {
  filterColumn: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: 2,
    width: '100%',

    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: theme.colors.neutral[200],

    py: theme.spacing(2),
  }),
} satisfies Styles;
